module.exports = __webpack_public_path__ + "static/img/fa.8fdee7e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/client/logo/fa.jpg
// module id = zrhV
// module chunks = 0